import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from './shared/common.service';
import 'firebase/database'
import { NetworkStatusService } from './shared/newtwork-service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { RlToast, RlToastService } from './shared/rl-toast.service';
declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit, OnDestroy {
  token="";
  title;
  offlineFlag:boolean=false;
  msgText=""
  alertTitle="";
  alertKind: 'offline' | 'online' = 'offline';
  msgTextFlag:boolean=false;
  subscription: Subscription;
  rlToast: RlToast | null = null;
  private toastSub: Subscription;
  constructor( public commonService:CommonService,
              public tostService:ToastrService,
               private networkStatusService: NetworkStatusService,
               private rlToastService: RlToastService){
  }
  ngOnInit(): void {
    this.title = 'RL-Board';
    this.removeBootLoader();
    this.toastSub = this.rlToastService.toast$.subscribe((toast) => {
      this.rlToast = toast;
    });
    this.networkStatusService.isOnline.subscribe(isOnline => {
      if (!isOnline) {
        this.offlineFlag=true;
        this.alertKind='offline';
        this.alertTitle="You're offline";
        this.msgText='Some features may not be available until your connection is restored.';
        this.openModal('confirm')
      } else {
        if(this.offlineFlag){
          this.alertKind='online';
          this.alertTitle="You're back online";
          this.msgText='Your connection has been restored.';
        this.offlineFlag=false;
        this.openModal('confirm')
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.toastSub?.unsubscribe();
  }

  openModal(modalId: string) {
    $(`#${modalId}`).modal('show');
  }
  
  closeModal(modalId: string) {
    $(`#${modalId}`).modal('hide');
  }

  close(){
    this.msgTextFlag=false;
  }

  private removeBootLoader() {
    const boot = document.getElementById('rb-boot-loader');
    if (!boot) {
      return;
    }
    // Keep boot splash until Angular loader is mounted; hide on next frame.
    requestAnimationFrame(() => {
      boot.classList.add('is-hidden');
      setTimeout(() => boot.remove(), 160);
    });
  }
}
  


